import { ref } from 'vue';
import validateObjectValue from '@/functions/validate_object_value';

// by convention, composable function names start with "use"
export function useActiveFilter() {
  // Refs as per normal
  const isActiveFilter = ref(false);

  // any function you may need that can update the ref
  function validateFilterOptions(options) {
    isActiveFilter.value = validateObjectValue(options);
  }

  // expose any refs and functions you may need
  return { isActiveFilter, validateFilterOptions };
}
